import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-expand-input',
  templateUrl: './ui-expand-input.component.html',
  styleUrls: ['./ui-expand-input.component.scss']
})
export class UiExpandInputComponent {
  public text: string;

  @Input() public placeholder = '';
  @Input() public align = 'right';

  @Output() public modelChange = new EventEmitter<string>();

  @Input()
  public get model() {
    return this.text;
  }

  public set model(text: string) {
    this.text = text;
    this.modelChange.emit(text);
  }
}
